import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 45 45",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-secondary",
			d: "M22.5 23c-4.6 0-8.4-3.8-8.4-8.4 0-2.6 1.3-5.1 3.4-6.7.6-.4 1.3-.3 1.7.3.4.6.3 1.3-.3 1.7-1.5 1.1-2.4 2.8-2.4 4.7 0 3.2 2.6 5.9 5.9 5.9 3.2 0 5.9-2.6 5.9-5.9 0-1.9-.9-3.6-2.4-4.7-.6-.4-.7-1.2-.3-1.7.4-.6 1.2-.7 1.7-.3 2.1 1.6 3.4 4 3.4 6.7.2 4.7-3.6 8.4-8.2 8.4z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-secondary",
			d: "M22.5 13.9c-.7 0-1.2-.6-1.2-1.2V6c0-.7.6-1.2 1.2-1.2s1.2.6 1.2 1.2v6.6c.1.8-.5 1.3-1.2 1.3z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-primary",
			d: "M45 16.7c0-1.8-1.5-3.3-3.3-3.3h-4.6C36.5 5.9 30.2 0 22.5 0c-7.7 0-14 5.9-14.6 13.4H3.3c-1.8 0-3.3 1.5-3.3 3.3v23.6h3.7V45h10.6v-4.6h16.4V45h10.6v-4.6H45V16.7zM22.5 2.5c6.7 0 12.2 5.5 12.2 12.2 0 6.5-5.5 11.7-12.2 11.7s-12.2-5.3-12.2-11.7c0-6.7 5.5-12.2 12.2-12.2zM3.3 15.9h4.6c.7 7.3 7 13 14.6 13s13.9-5.7 14.6-13h4.6c.5 0 .8.4.8.8v15.4h-40V16.7c0-.4.4-.8.8-.8zm8.5 26.6H6.2v-2.1h5.6v2.1zm27 0h-5.6v-2.1h5.6v2.1zm2.5-4.6H2.5v-3.2h40v3.2h-1.2z"
		})
	]
});
export default SvgIcon;
